import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useMemo } from "react";
import { Avatar as AntAvatar, Badge } from "antd";
import classNames from "classnames";
import "./Avatar.scss";
import { styleClasses } from "../../helpers";
import { Text } from "../../particles/Text";
const { Group } = AntAvatar;
const CSS_PREFIX = `lav-components-avatar`;
const CSS_BADGE_PREFIX = `lav-components-badge`;
const getBadgeOffset = (size, shape, count, position) => {
    if (shape === "square") {
        return;
    }
    let offsetValue;
    let originalValue;
    if (size === "small") {
        originalValue = 24;
        offsetValue = 3;
    }
    else if (size === "medium") {
        originalValue = 32;
        offsetValue = count && typeof count === "number" ? (count > 9 ? 0 : 3) : 5;
    }
    else {
        originalValue = 40;
        offsetValue = count && typeof count === "number" ? (count > 9 ? 3 : 5) : 7;
    }
    switch (position) {
        case "top-right":
            return [-offsetValue, offsetValue];
        case "top-left":
            return [-originalValue - offsetValue, offsetValue];
        case "bottom-left":
            return [-originalValue - offsetValue, originalValue + offsetValue];
        case "bottom-right":
        default:
            return [-offsetValue, originalValue];
    }
};
const BadgeWrapper = ({ badge, children, shape, size }) => {
    if (badge === undefined) {
        return children;
    }
    const badgeSize = size === "small" ? "small" : "default";
    const { dot, count, color, className = "", position = "bottom-right" } = badge, badgeProps = __rest(badge, ["dot", "count", "color", "className", "position"]);
    return (_jsx(Badge, Object.assign({}, badgeProps, { dot: dot, count: size === "extra-small" ? undefined : count, size: dot ? badgeSize : "small", offset: getBadgeOffset(size, shape, count, position), className: classNames(styleClasses(CSS_BADGE_PREFIX, {}), {
            [className]: !!className,
        }), classNames: {
            indicator: classNames(styleClasses(CSS_BADGE_PREFIX + "-indicator", { color })),
        }, children: children })));
};
const Avatar = forwardRef((_a, ref) => {
    var { icon, children, src, className = "", color = "lavender", size = "medium", type = "solid", badge } = _a, antAvatarProps = __rest(_a, ["icon", "children", "src", "className", "color", "size", "type", "badge"]);
    const wrappedText = useMemo(() => {
        if (!children)
            return children;
        switch (size) {
            case "extra-small":
            case "small":
                return _jsx(Text, { size: "subtext1", children: children });
            case "medium":
                return _jsx(Text, { size: "subtext2", children: children });
            case "large":
                return _jsx(Text, { size: "subtext3", children: children });
            case "extra-large":
                return _jsx(Text, { size: "subtext5", children: children });
        }
    }, [children, size]);
    return (_jsx(BadgeWrapper, Object.assign({ badge: ["small", "medium"].includes(size) ? badge : undefined, size: size }, antAvatarProps, { children: _jsx(AntAvatar, Object.assign({ icon: icon, ref: ref, src: src, className: classNames(styleClasses(CSS_PREFIX, {
                color,
                size,
                src,
                type,
            }), { [className]: !!className }) }, antAvatarProps, { children: wrappedText })) })));
});
Avatar.displayName = "Avatar";
Avatar.Group = Group;
export default Avatar;
